export const ExpandIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15 2C15 1.44772 14.5523 1 14 1H10C9.44771 1 9 1.44772 9 2C9 2.55228 9.44771 3 10 3L11.5858 3L8.79289 5.7929C8.40237 6.18342 8.40237 6.81659 8.79289 7.20711C9.18342 7.59763 9.81658 7.59763 10.2071 7.20711L13 4.41421L13 6C13 6.55229 13.4477 7 14 7C14.5523 7 15 6.55229 15 6L15 2Z"
      fill="currentColor"
    />
    <path
      d="M1 14C1 14.5523 1.44772 15 2 15L6 15C6.55229 15 7 14.5523 7 14C7 13.4477 6.55229 13 6 13L4.41421 13L7.20711 10.2071C7.59763 9.81658 7.59763 9.18342 7.20711 8.7929C6.81658 8.40237 6.18342 8.40237 5.79289 8.7929L3 11.5858L3 10C3 9.44772 2.55228 9 2 9C1.44771 9 1 9.44772 1 10L1 14Z"
      fill="currentColor"
    />
  </svg>
);
